import { defineComponent } from 'vue';
import TopMenu from './topmenu.vue';

import { useI18n } from '@/i18n-shim'

export default defineComponent({
  name: 'esign-layout',

  components: {
    topmenu: TopMenu
  },
  props: {
    loginInfo: {
      type: Object,
      required: false
    },
    showLogoutButton: {
      type: Boolean,
      default: false
    },
    tenantId: {
      type: String,
      required: true
    }
  },
  emits: ['logout'],
  setup(props, context) {
    return {
      ...useI18n(),
      logout: function () {
        context.emit('logout');
      }
    }
  }
});
